import {AxiosError, AxiosResponse} from "axios"
import {get} from "lodash"
import Generic from "../../../errorCodes/Generic"

export default function isMFARequired(err: AxiosError) {
  return get(err, "response.data.code") === Generic.PBERRMFARequired
}

export function isGraphMFARequired(res: AxiosResponse) {
  const useErrorHandler = get(res, "config.useErrorHandler", true)
  let found = false
  if (useErrorHandler && res.data) {
    if (Array.isArray(res.data.errors)) {
      res.data.errors.forEach(({errorCode}: any) => {
        if (errorCode === Generic.PBERRMFARequired) {
          found = true
        }
      })
    }
  }

  return found
}
